module.exports = __webpack_public_path__ + "static/media/ellipsis-live.e4c73be7.svg";